var map = {
	"./quiz_stage_10_bg.svg": "4zZR",
	"./quiz_stage_11_bg.svg": "GsyP",
	"./quiz_stage_1_bg.svg": "khDs",
	"./quiz_stage_2_bg.svg": "ibr7",
	"./quiz_stage_3_bg.svg": "iZ7Q",
	"./quiz_stage_4_bg.svg": "6o4k",
	"./quiz_stage_5_bg.svg": "l9ue",
	"./quiz_stage_6_bg.svg": "cNUB",
	"./quiz_stage_7_bg.svg": "QivE",
	"./quiz_stage_8_bg.svg": "T1IS",
	"./quiz_stage_9_bg.svg": "AghV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jzmI";